import { Col, Row, Space } from 'antd'
import { MyTheme } from 'Components/common/Theme'
import { Doughnut } from 'Components/utilities/Chart'
import { DashboardDataType } from 'helpers/constanst'
import { numberWithComma } from 'helpers/format'
import { genColor } from 'helpers/utils'
import React from 'react'
import { ProductData } from 'Store/dashboard/types'
import styled from 'styled-components'

type Props = {
  data: ProductData[]
  type: DashboardDataType
}

const ProductChart: React.FunctionComponent<Props> = props => {
  const { data: product, type } = props

  const getResult = () => {
    const label = [] as string[]
    const price = [] as number[]
    const quantitly = [] as number[]
    const color = [] as string[]
    product.forEach((item, index) => {
      label.push(item.title)
      price.push(item.total_price)
      quantitly.push(item.total_quantity)
      color.push(genColor(index))
    })
    return { label: label, price: price, quantitly: quantitly, color: color }
  }

  const getLable = (label: string, value: number) => {
    if (type === DashboardDataType.SALE) {
      return `${label} ยอดขาย ${numberWithComma(value, true)} บาท`
    } else {
      return `${label} จำนวน ${numberWithComma(value)} ชิ้น`
    }
  }

  const options = {
    // indexAxis: 'x',
    indexAxis: 'y',
    elements: {
      bar: {
        borderWidth: 1,
      },
    },
    responsive: true,
    legend: {
      display: false,
      position: 'bottom',
    },
    title: {
      display: false,
      text: '',
    },
    tooltips: {
      callbacks: {
        label: (tooltipItem: any, data: any) => {
          const value = data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index] || 0
          const label = data.labels[tooltipItem.index] || ''
          return getLable(label, value)
        },
      },
    },
  }

  const result = getResult()

  const data = {
    labels: result.label,
    datasets: [
      {
        label: '',
        data: type === DashboardDataType.SALE ? result.price : result.quantitly,
        backgroundColor: result.color,
        borderColor: result.color,
        borderWidth: 2,
      },
    ],
  }

  return (
    <Row gutter={[16, 16]}>
      <Col lg={24} xs={24}>
        <Doughnut data={data} options={options} />
      </Col>
      <Col lg={24} xs={24}>
        <Row align="top" gutter={[8, 8]}>
          {result &&
            result?.color?.map((item: any, index) => {
              return (
                <Col lg={12} sm={24} key={index}>
                  <Space>
                    <Point style={{ backgroundColor: item }} />
                    <Legend>
                      {index + 1}.{result?.label[index]}
                    </Legend>
                  </Space>
                </Col>
              )
            })}
        </Row>
      </Col>
    </Row>
  )
}

const Legend = styled.span`
  color: ${(props: { theme: MyTheme }): string => props.theme.colors.grey};
  font-size: ${(props: { theme: MyTheme }): string => props.theme.typography.body4};
  font-family: ${(props: { theme: MyTheme }): string => props.theme.fontFamily.primary};
`

const Point = styled.div`
  width: 12px;
  height: 12px;
  border-radius: 50%;
`

export default ProductChart
